import styled from 'styled-components/macro';

const EditWrapper = styled.div<{ isEditable: boolean }>`
    pointer-events: ${(props) => (props.isEditable ? 'auto' : 'none')};
    opacity: ${(props) => (props.isEditable ? '1' : '0.6')};
`;

export default EditWrapper;
